<loading [visible]="loading() || saving()"></loading>

@if(!loading()){
<app-custom-modal maxWidth="5xl"
    [customTitle]="(id ? 'Editar' : 'Nuevo') + ' proveedor' +  (saveForm.get('id_by_company')?.value ? ' : ' + saveForm.get('id_by_company')?.value : '')"
    (closeFunction)="closeFormFunction()" (acceptFunction)="acceptFormFunction()">
    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="space-y-6">

        <div class="max-w-5xl grid grid-cols-1 md:grid-cols-2 gap-3">


            <section class="border border-gray-200 col-span-2 shadow p-3 rounded-xl">
                <h3 class="text-xs font-bold text-black uppercase tracking-[0.2em] border-b-2 border-black pb-2 mb-6">
                    Información General
                </h3>
                <div class="grid grid-cols-1 md:grid-cols-4 gap-2">
                    <div class="md:col-span-2">
                        <custom-input [autofocus]="true" label="Nombre del proveedor"
                            placeholder="Ej: Jose de los santos"
                            [formControlItem]="saveForm.get('name')"></custom-input>
                    </div>
                    <custom-input label="Código" placeholder="CLI-001"
                        [formControlItem]="saveForm.get('code')"></custom-input>

                    <custom-input label="NIF / CIF" placeholder="12345678Z"
                        [formControlItem]="saveForm.get('nif')"></custom-input>

                    <div class="md:col-span-2">
                        <custom-input label="Reclamo Comercial"
                            [formControlItem]="saveForm.get('commercial_claim')"></custom-input>
                    </div>
                    <div class="md:col-span-2">
                        <custom-input label="Email Principal" type="email" placeholder="ejemplo@correo.com"
                            [formControlItem]="saveForm.get('email')"></custom-input>
                    </div>
                    <custom-input label="Persona de Contacto"
                        [formControlItem]="saveForm.get('contact_person')"></custom-input>
                    <custom-input label="Teléfono 1" [formControlItem]="saveForm.get('phone_1')"></custom-input>
                    <custom-input label="Teléfono 2" [formControlItem]="saveForm.get('phone_2')"></custom-input>
                    <custom-input label="Cuenta Contable" class="col-span-1"
                        [formControlItem]="saveForm.get('accounting_account')"></custom-input>
                    <custom-select label="Método de pago" [formControlItem]="saveForm.controls['payment_method_id']"
                        [options]="dropdowns.pay_methods" bindValue="id" bindLabel="name" [isMultiple]="false"
                        placeholder="Selecciona un método de pago" [createComponent]="payMethodFormComponent"
                        (itemCreated)="getDropdowns()">
                    </custom-select>
                </div>
            </section>

            <section class="border border-gray-200 shadow p-3 rounded-xl">
                <h3 class="text-xs font-bold text-black uppercase tracking-[0.2em] border-b-2 border-black pb-2 mb-6">
                    Ubicación
                </h3>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div class="md:col-span-2">
                        <custom-input label="Dirección Completa"
                            [formControlItem]="saveForm.get('address')"></custom-input>
                    </div>
                    <custom-input label="Población" [formControlItem]="saveForm.get('city')"></custom-input>
                    <custom-input label="Provincia" [formControlItem]="saveForm.get('province')"></custom-input>
                    <custom-input label="Código Postal" [formControlItem]="saveForm.get('postal_code')"></custom-input>
                    <custom-select label="País" [formControlItem]="saveForm.controls['country']"
                        [options]="dropdowns.countries" bindValue="code" bindLabel="name" [isMultiple]="false"
                        placeholder="Selecciona un país">
                    </custom-select>
                </div>
            </section>

            <section class="border border-gray-200 shadow p-3 rounded-xl">
                <label class="block mb-2 text-sm font-bold text-black uppercase tracking-widest">Notas internas</label>
                <textarea tabindex="-1"
                    class="w-full px-4 py-4 text-sm border border-black rounded-2xl bg-white focus:outline-none focus:ring-2 focus:ring-black/5 focus:border-black transition-all min-h-30"
                    rows="4" formControlName="note"
                    placeholder="Escribe aquí cualquier observación relevante..."></textarea>
            </section>

        </div>

    </form>
</app-custom-modal>
}